export const DEVICE_ID_HEADER = 'X-Device-ID';
